module.exports = __webpack_public_path__ + "assets/img/a15a-mw.svg";